import { Button } from '@/components/button';
import { Modal, ModalBody, ModalButtonContainer } from '@/components/modal/modal';
import { SuccessCircleSvg } from '@/components/svgs/success-circle';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './support-success-modal.module.css';

interface SupportSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}
export function SupportSuccessModal({ isOpen, onClose, onSubmit }: SupportSuccessModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.modal}>
      <SuccessCircleSvg className={styles.successCircle} />
      <h2 className="h3">{t('support.successModal.title')}</h2>

      <ModalBody>{t('support.successModal.body')}</ModalBody>

      <ModalButtonContainer className={styles.buttonContainer}>
        <Button onClick={onSubmit}>{t('common.continue')}</Button>
      </ModalButtonContainer>
    </Modal>
  );
}
